import { ComponentInternalInstance, getCurrentInstance, computed, onUnmounted, ref, watch } from '@vue/composition-api';

import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import { Args } from '@/renderer/scripts/utils/GuideHelper';
// 新手引导的状态控制
export default function sidebarGuideHandler() {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const store = vm.$store;
  // 工作台新手引导的数据
  const workbenchSteps = computed<Array<Args>>(() => {
    const { hasPersonalSpace } = store.getters;
    const notPersonal: boolean = store.getters.editionFlag !== 'personal';
    const isTeam = store.getters.editionFlag === 'team';
    const isEnterPrise = store.getters.editionFlag === 'enterprise';
    const isAdmin = store.getters.userBaseInfo.role !== 'user';
    const personalSpaceArgs = hasPersonalSpace
      ? [
          {
            id: 'personalSpace',
            title: i18n_t('个人空间'),
            context: i18n_t('办公资料上传到这里，无论身在何处都能轻松访问。'),
          },
        ]
      : [];
    const newGuide = hasPersonalSpace
      ? [
          {
            id: 'smh-guide',
            title: notPersonal && isAdmin ? i18n_t('更多操作攻略') : i18n_t('新手任务引导 '),
            context:
              notPersonal && isAdmin
                ? i18n_t('我们提供了操作指引与管理攻略，能够帮助你更快的掌握产品功能。')
                : i18n_t('我们提供了一些任务，能够帮助你更快的掌握特色功能。'),
            type: 'Workbench',
            className: 'guide-workbench top-more',
            position: 'bottom-left',
          },
        ]
      : [];
    const teamSpaceArgs = notPersonal
      ? [
          {
            id: 'teamSpace',
            title: i18n_t('企业空间'),
            context: i18n_t('{slot1}的规范，协作完成的项目资料均可安全汇聚于此。', {
              slot1: isTeam ? i18n_t('团队') : i18n_t('公司'),
            }),
          },
        ]
      : [];
    const stepArguments: Array<Args> = [
      ...personalSpaceArgs,
      ...teamSpaceArgs,
      {
        id: 'collaborationSpace',
        title: i18n_t('协作空间'),
        context: i18n_t('邀请同事和合作伙伴共享协作，项目效率轻易翻倍。'),
      },
      {
        id: 'linkManage',
        title: i18n_t('安全外链'),
        context: `${
          isEnterPrise
            ? i18n_t('生成客户方案、交付资料分享链接，只有你指定的人才能打开。')
            : i18n_t('超大文件上传下载不限速，只有你指定的人才能访问。')
        }`,
      },
      {
        id: 'recycleBin',
        title: i18n_t('误删恢复'),
        context: i18n_t('不小心被误删的文档，都可以在这里找到并恢复。'),
      },
      ...newGuide,
    ];
    return stepArguments;
  });
  // 是否在新手引导状态
  const inGuide = ref<boolean>(false);
  let timer: number | undefined;
  watch(
    () => inGuide.value,
    (val: boolean) => {
      if (val) {
        timer = window.setInterval(() => {
          // 监听遮罩是否存在就能判断是否在引导中
          const driver = document.getElementById('driver-page-overlay');
          if (driver === null) {
            inGuide.value = false;
          }
        }, 1000);
      } else {
        window.clearInterval(timer);
        timer = undefined;
      }
    },
  );
  const startGuide = () => {
    inGuide.value = true;
  };
  const stopGuide = () => {
    inGuide.value = false;
    window.clearInterval(timer);
    timer = undefined;
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.START_GUIDE, startGuide);
  ipc.on(ipc.RENDERER_EVENTS_MAP.STOP_GUIDE, stopGuide);
  onUnmounted(() => {
    ipc.off(ipc.RENDERER_EVENTS_MAP.START_GUIDE, startGuide);
    ipc.off(ipc.RENDERER_EVENTS_MAP.STOP_GUIDE, stopGuide);
  });
  return {
    inGuide,
    workbenchSteps,
  };
}
